export default "__VITE_ASSET__CDOpnsjk__"